import 'whatwg-fetch';
import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';

import Provider from 'providers/createProvider';
import config from 'utils/config';
import { getLaunchDarklyContext } from 'utils/launchDarkly';

import App from './App';

import { CONFIGURE_SUBSCRIPTION_RENEWAL_OVERLAP } from 'constants/launchDarkly';

const sentryDsn = config('SENTRY_DSN');
const sentryEnv = config('SENTRY_ENVIRONMENT') || 'dev';
const release = config('RELEASE');

const launchDarklyClientId = config('LAUNCHDARKLY_CLIENT_ID');

const render = async () => {
  if (sentryDsn && release) {
    Sentry.init({
      dsn: sentryDsn,
      environment: sentryEnv,
      release
    });
  }

  const LDProvider = await asyncWithLDProvider({
    clientSideID: launchDarklyClientId,
    context: await getLaunchDarklyContext('voyager-app'),
    options: {
      streaming: false,
      sendEvents: false,
      fetchGoals: false
    },
    flags: {
      [CONFIGURE_SUBSCRIPTION_RENEWAL_OVERLAP]: 30
    },
    reactOptions: {
      useCamelCaseFlagKeys: false
    }
  });

  // eslint-disable-next-line react/no-deprecated
  ReactDOM.render(
    <LDProvider>
      <Provider>
        <Sentry.ErrorBoundary>
          <App />
        </Sentry.ErrorBoundary>
      </Provider>
    </LDProvider>,
    document.getElementById('root')
  );
};

render();
